import { render, staticRenderFns } from "./Form1_Persona.vue?vue&type=template&id=dccd4b9c"
import script from "./Form1_Persona.vue?vue&type=script&lang=js"
export * from "./Form1_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dccd4b9c')) {
      api.createRecord('dccd4b9c', component.options)
    } else {
      api.reload('dccd4b9c', component.options)
    }
    module.hot.accept("./Form1_Persona.vue?vue&type=template&id=dccd4b9c", function () {
      api.rerender('dccd4b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/PRESTAMA/Form1_Persona.vue"
export default component.exports